import React, { useEffect, useState, useContext } from 'react'
import { Col, Row, Container } from 'react-bootstrap'
// import axios from 'axios'
import { AuthContext } from '../AuthContext'

import PowerFans from './PowerFans'
import Interaction from './Interaction'
import PowerScan from './PowerScan'
import AITeacher from '../AITeacher'
import Radar from './Radar'
import TrendTracking from './TrendTracking'
import { Helmet } from 'react-helmet'

// import 'chart.js/auto'
// import { Doughnut } from 'react-chartjs-2'
import ReactEcharts from 'echarts-for-react'
import { useAPI } from '../../hooks/useAPI'

const PowerComponent = () => {
  const { currentUser, brandArr } = useContext(AuthContext)

  const GetLast = 'powerAnalysis/v1/GetLast'
  const [data, setData] = useState({
    ai_teacher_comment: '',
    mean_like_yt: 0,
    mean_like_ig: 0,
    radar_fanres_val: 0,
    mean_comment_fb: 0,
    radar_sumfoc_val: 0,
    radar_emofoc_val: 0,
    mean_share_yt: 0,
    mean_touch_fb: 0,
    count_yt: 0,
    sumfoc_val: 0,
    newatt_val: 0,
    fanres_val: 0,
    count_ig: 0,
    mean_share_ig: 0,
    mean_watch_fb: 0,
    mean_like_fb: 0,
    mean_comment_ig: 0,
    mean_comment_yt: 0,
    radar_newatt_val: 0,
    mean_share_fb: 0,
    radar_avefoc_val: 0,
    mean_watch_ig: 0,
    emofoc_val: 0,
    ai_teacher_advice: '',
    count_fans: 0,
    mean_touch_yt: 0,
    avefoc_val: 0,
    mean_touch_ig: 0,
    mean_watch_yt: 0,
    count_fb: 0,
  })

  const requestBody = currentUser.lv === 2 ? { kol_id: currentUser.kol_id } : {}

  const { fetchData } = useAPI({
    path: GetLast,
    requestBody: requestBody,
    initData: data,
    msg: '綜合分析',
    dependencies: [],
  })

  useEffect(() => {
    setData(fetchData)
  }, [fetchData])

  // 粉絲數量圓餅圖
  // const config = {
  //   // type: 'doughnut',
  //   // data: data,
  //   options: {
  //     responsive: true,
  //     plugins: {
  //       legend: {
  //         position: 'bottom',
  //       },
  //       title: {
  //         display: true,
  //         text: '粉絲數量分布',
  //       },
  //     },
  //   },
  // }

  // const doughnutData = {
  //   datasets: [
  //     {
  //       // label: '',
  //       data: [data[0].count_fb, data[0].count_ig, data[0].count_yt],
  //       backgroundColor: ['#4267B2', '#C13584', '#ff0000'],
  //       hoverOffset: 4,
  //     },
  //   ],
  //   labels: ['FB', 'IG', 'YT'],
  // }

  const doughnutOption = {
    tooltip: {
      trigger: 'item',
      formatter: '{b} {c} (人)',
    },
    legend: {
      top: 'bottom',
      left: 'center',
    },
    series: [
      {
        name: '粉絲數量分布',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center',
        },
        itemStyle: {
          borderRadius: 5,
          borderColor: '#fff',
          borderWidth: 3,
        },
        emphasis: {
          label: {
            show: false,
            fontSize: 10,
            fontWeight: 'bold',
          },
        },
        labelLine: {
          show: false,
        },
        data: brandArr.map((v) => {
          return {
            value:
              data['count_' + v.brand] === '尚無資料'
                ? 0
                : data['count_' + v.brand],
            name: v.title,
          }
        }),
        color: ['#4267B2', '#C13584', '#FF0000'],
      },
    ],
  }
  return (
    <>
      <Helmet>
        <title>綜合分析 | KOLSTAR</title>
      </Helmet>
      <main className="power">
        <Container className="section1">
          <Row className="d-flex flex-column-reverse flex-md-row">
            <Col
              xs={12}
              md={5}
              className="flex-grow-1 text-nowrap overflowX mt-auto"
            >
              <PowerFans data={data} />
            </Col>
            <Col md={4} className="mx-lg-3 px-lg-3 order-md-1 m-auto">
              <ReactEcharts
                style={{ width: '100%', height: '300px' }}
                className="w-100"
                option={doughnutOption}
              />
              {/* <Doughnut data={doughnutData} options={config.options} /> */}
            </Col>
            {/* <div className="col-md-5 mx-lg-3 px-lg-3 order-md-1 w-auto m-auto"></div> */}
          </Row>
        </Container>
        <Container className="section2">
          <Row>
            <Interaction data={data} title="經營互動指標" brandArr={brandArr} />{' '}
          </Row>
        </Container>
        <Container className="section3">
          <Row>
            <PowerScan data={data} title="戰力掃描" />{' '}
          </Row>
        </Container>
        <Container className="section4">
          <Row>
            <AITeacher data={data} title="AI 導師建議" />{' '}
          </Row>
        </Container>
        <Container className="section5">
          <Row>
            <Radar data={data} title="優勢雷達圖" />{' '}
          </Row>
        </Container>
        <Container className="section6">
          <Row>
            <TrendTracking
              currentUser={currentUser}
              title="戰力趨勢追蹤"
              brandArr={brandArr}
            />
          </Row>
        </Container>
      </main>
    </>
  )
}

export default PowerComponent
